// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
p,
h2,
h3 {
  margin: 0;
}

main {
  display: block;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

a {
  display: block;
  background-color: transparent;
  text-decoration: none;
}

img {
  border-style: none;
}

button {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  overflow: visible;
  text-transform: none;
}

body {
  background-color: #f5f6f5;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;
  white-space: nowrap;
  -webkit-clip-path: inset(100%);
          clip-path: inset(100%);
  clip: rect(0 0 0 0);
  overflow: hidden;
}

button {
  cursor: pointer;
  border: none;
}

input {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/normalize.scss","webpack://./src/styles/style.scss","webpack://./src/styles/globals.scss"],"names":[],"mappings":"AAAA;;;;EAIE,SAAA;ACCF;;ADEA;EACE,cAAA;ACCF;;ADEA;EACE,UAAA;EACA,SAAA;EACA,gBAAA;ACCF;;ADEA;EACE,cAAA;EACA,6BAAA;EACA,qBAAA;ACCF;;ADEA;EACE,kBAAA;ACCF;;ADEA;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;ACCF;;AClCA;EACE,yBAAA;ADqCF;;AClCA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;UAAA,sBAAA;EACA,mBAAA;EACA,gBAAA;ADqCF;;AClCA;EACE,eAAA;EACA,YAAA;ADqCF;;AClCA;EACE,YAAA;ADqCF","sourcesContent":["body,\np,\nh2,\nh3 {\n  margin: 0;\n}\n\nmain {\n  display: block;\n}\n\nul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\na {\n  display: block;\n  background-color: transparent;\n  text-decoration: none;\n}\n\nimg {\n  border-style: none;\n}\n\nbutton {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n  overflow: visible;\n  text-transform: none;\n}\n","body,\np,\nh2,\nh3 {\n  margin: 0;\n}\n\nmain {\n  display: block;\n}\n\nul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\na {\n  display: block;\n  background-color: transparent;\n  text-decoration: none;\n}\n\nimg {\n  border-style: none;\n}\n\nbutton {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n  overflow: visible;\n  text-transform: none;\n}\n\nbody {\n  background-color: #f5f6f5;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  border: 0;\n  padding: 0;\n  white-space: nowrap;\n  clip-path: inset(100%);\n  clip: rect(0 0 0 0);\n  overflow: hidden;\n}\n\nbutton {\n  cursor: pointer;\n  border: none;\n}\n\ninput {\n  border: none;\n}","body {\n  background-color: #f5f6f5;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  border: 0;\n  padding: 0;\n  white-space: nowrap;\n  clip-path: inset(100%);\n  clip: rect(0 0 0 0);\n  overflow: hidden;\n}\n\nbutton {\n  cursor: pointer;\n  border: none;\n}\n\ninput {\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
